import http from '../http.js'

export const AiImageApi = {
  CREATE_TASK: '/api/aigc/image/v1/image-generation/create-task',
  GET_TASK_RESULT: '/api/aigc/image/image-generation/get-task-result',
  GET_TASK_HISTORY: '/api/aigc/image/image-generation/get-history',
  DELETE_TASK: '/api/aigc/image/image-generation/delete-task',
}

function serializeQuery(params) {
  const parts = []
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === '') continue
    if (Array.isArray(value)) {
      for (const item of value) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`)
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    }
  }
  return parts.length ? `?${parts.join('&')}` : ''
}

/** @param {Record<string, unknown>} data */
export const createAiImageTask = (data) =>
  http.post(AiImageApi.CREATE_TASK, data)

/** @param {{ task_id: string }} params */
export const getAiImageTaskResult = (params) =>
  http.get(AiImageApi.GET_TASK_RESULT, params)

/** @param {{ page?: number, size?: number }} params */
export const getAiImageTaskHistory = (params = {}) =>
  http.get(
    `${AiImageApi.GET_TASK_HISTORY}${serializeQuery({
      ...params
    })}`,
  )

/** @param {{ task_ids: string[] }} data */
export const deleteAiImageTask = (data) =>
  http.post(AiImageApi.DELETE_TASK, data)
